import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
  HStack,
} from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';
import { useNavigate } from 'react-router-dom';

export default function ProfileWarningBanner({ user }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToProfile = () => {
    navigate('/profile');
  };

  // Determine if user is a partner
  const isPartner = user?.role === 'partner';

  // Get appropriate description based on role
  const getDescription = () => {
    if (isPartner) {
      return t(
        'profile.incompleteDescriptionPartner',
        {
          fallback:
            'Please complete your profile information (Company, Phone, Address, City, Post Code, VAT Number) to access all features.',
        },
      );
    }
    return t(
      'profile.incompleteDescriptionClient',
      {
        fallback:
          'Please complete your profile information (Phone Number) to access all features.',
      },
    );
  };

  return (
    <Alert status="warning" variant="left-accent" borderRadius="md">
      <AlertIcon />
      <HStack justify="space-between" align="center" w="100%" flexWrap="wrap" gap={2}>
        <AlertTitle>{t('profile.incompleteTitle', { fallback: 'Profile Incomplete' })}</AlertTitle>
        <AlertDescription flex="1" minW="200px">
          {getDescription()}
        </AlertDescription>
        <Button size="sm" colorScheme="orange" onClick={handleGoToProfile}>
          {t('profile.goToProfile', { fallback: 'Go to Profile' })}
        </Button>
      </HStack>
    </Alert>
  );
}
